import { PimClass } from "@dataspecer/core/pim/model";
import { POJEM, RDFS } from "../sgov-vocabulary.js";
import { loadSgovEntityToResource } from "./sgov-entity-adapter.js";
export async function isSgovClass(entity) {
    return (await entity.types()).includes(POJEM.typObjektu);
}
export async function loadSgovClass(entity, idProvider) {
    const result = new PimClass();
    await loadSgovEntityToResource(entity, idProvider, result);
    result.pimIsCodelist =
        (await entity.property("__is_ciselnik"))[0]?.value === "1";
    result.pimExtends = unique([
        ...result.pimExtends,
        ...(await entity.nodes(RDFS.subClassOf)).map(idProvider.cimToPim),
    ]);
    return result;
}
function unique(values) {
    return [...new Set(values)];
}
//# sourceMappingURL=sgov-class-adapter.js.map